import { CLEAR_DRAFT, PREPARE_DRAFT, TOUCHED_DRAFT } from '../actions/drafts'

const draft = (state = {}, action = {}) => {
  switch (action.type) {
    case CLEAR_DRAFT:
      state = {}
      break
      case TOUCHED_DRAFT:
      state = {
        ...state,
        touched: action.payload
      }
      break
    case PREPARE_DRAFT:
      state = {
        ...state,
        value: action.payload
      }
      break
  }
  return state
}

export default draft
